import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useErrorStore = defineStore('error', () => {
  const errors = ref([])
  const selectedErrorId = ref(null)

  const setError = (errorData) => {
    // Add timestamp and unique ID to error
    const errorWithId = {
      ...errorData,
      id: Date.now() + Math.random(),
      timestamp: new Date().toISOString()
    }
    
    // Add to beginning of array (newest first)
    errors.value.unshift(errorWithId)
    
    // Auto-select the new error
    selectedErrorId.value = errorWithId.id
  }

  const selectError = (errorId) => {
    selectedErrorId.value = errorId
  }

  const removeError = (errorId) => {
    const index = errors.value.findIndex(e => e.id === errorId)
    if (index !== -1) {
      errors.value.splice(index, 1)
      
      // If we removed the selected error, select another one or clear selection
      if (selectedErrorId.value === errorId) {
        if (errors.value.length > 0) {
          selectedErrorId.value = errors.value[0].id
        } else {
          selectedErrorId.value = null
        }
      }
    }
  }

  const clearAllErrors = () => {
    errors.value = []
    selectedErrorId.value = null
  }

  const selectedError = computed(() => {
    if (!selectedErrorId.value) return null
    return errors.value.find(e => e.id === selectedErrorId.value) || null
  })

  const hasErrors = computed(() => errors.value.length > 0)

  return {
    errors,
    selectedErrorId,
    selectedError,
    hasErrors,
    setError,
    selectError,
    removeError,
    clearAllErrors
  }
})